// extracted by mini-css-extract-plugin
export default {"l_AccountPage_main":"AccountPage_l_AccountPage_main__17w40"};